
import React from 'react';
import { Eye, Star, Zap } from 'lucide-react';

const AvantagesSection = () => {
  const avantages = [
    {
      icon: Eye,
      title: "Reconnaissance instantanée",
      description: "Une identité forte qui se démarque de la concurrence"
    },
    {
      icon: Star,
      title: "Crédibilité renforcée",
      description: "Une image professionnelle qui inspire confiance"
    },
    {
      icon: Zap,
      title: "Cohérence parfaite",
      description: "Une harmonie visuelle sur tous vos supports"
    }
  ];

  return (
    <section className="py-20 bg-gradient-to-br from-blue-600 to-navy-900">
      <div className="container mx-auto px-6">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-4xl font-light text-white mb-6">
            Pourquoi investir dans une <span className="font-semibold text-pink-400">identité forte</span> ?
          </h2>
          <p className="text-xl text-navy-200 mb-12 font-light">
            Les bénéfices d'une identité visuelle professionnelle
          </p>
          
          <div className="grid md:grid-cols-3 gap-8">
            {avantages.map((avantage, index) => (
              <div key={index} className="text-center">
                <div className="bg-white/10 p-6 w-20 h-20 mx-auto mb-6 flex items-center justify-center">
                  <avantage.icon className="text-pink-400" size={32} />
                </div>
                <h3 className="text-xl font-semibold text-white mb-3">{avantage.title}</h3>
                <p className="text-navy-200 font-light">{avantage.description}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default AvantagesSection;
